<section class="c-new-infographic-banner infographic">
	<div class="infographic_wrapper">
		<div class="infographic_content">
			<h3>Learn more about<br> the infrastructure that<br> powers <strong>jsDelivr</strong></h3>
			<a class="btn-primary router-ignore" target="_blank" href="/network/infographic">Check our infographic</a>
		</div>

		<div class="infographic_image-desktop hidden">
			<img width="624" height="338" src="{{@shared.assetsHost}}/img/landing/new/infographics.png" srcset="{{@shared.assetsHost}}/img/landing/new/infographics@2x.png 2x" loading="lazy">
		</div>

		<div class="infographic_image hidden">
			<img width="280" height="205" src="{{@shared.assetsHost}}/img/landing/new/infographics.mobile.png" srcset="{{@shared.assetsHost}}/img/landing/new/infographics.mobile@2x.png 2x" loading="lazy">
		</div>
	</div>
</section>
